import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';

@Component({
    selector: 'app-edit-bloc-buttons',
    templateUrl: './edit-bloc-buttons.component.html',
    styleUrls: ['./edit-bloc-buttons.component.css'],
    standalone: false
})
export class EditBlocButtonsComponent implements OnInit {
  @Output() editEvent = new EventEmitter();

  @Output() deleteEvent = new EventEmitter();

  @Input() showDeleteB = true;

  constructor() { }

  ngOnInit() {}

}
